import Grade from '@material-ui/icons/Grade';
import { useTranslation } from 'react-i18next';

import { CloseIcon } from 'assets/icons';

import img from 'assets/images/betfan.webp';
import Button from 'shared/components/form/button';

interface Props {
	isShowInstall: boolean;
	onClickInstall: () => void;
	onClickClose: () => void;
}

const PWABanner: React.FC<Props> = (props: Props) => {
	const { isShowInstall } = props;
	const { t } = useTranslation();
	return (
		<>
			{isShowInstall && (
				<div className="pwa-banner flex align__items--center justify__content--between">
					<div style={{ lineHeight: '0' }} onClick={() => props.onClickClose()}>
						<CloseIcon className="close--icon pointer" />
					</div>
					<div className="banner-img">
						<img src={img} alt="pwa-banner" className="width--full" />
					</div>
					<div className="banner--desc">
						<p className="font--bold font-size--9 text--midnight-green no--margin">{t('installBanner')}</p>
						<p className="flex mt--0 mb--0">
							<Grade className="star--icon" />
							<Grade className="star--icon" />
							<Grade className="star--icon" />
							<Grade className="star--icon" />
							<Grade className="star--icon" />
						</p>
					</div>
					<Button
						cyTestRef="download-pwa"
						btnType="secondary"
						className="button font--bold text--primary font-size--10"
						onClick={() => props.onClickInstall()}
					>
						{t('download')}
					</Button>
				</div>
			)}
		</>
	);
};

export default PWABanner;
